import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { StatusService } from "../../../services/status.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { Navigation } from "../../../model/navigation";
import { Messages } from "../../../model/messages";
import { Status } from "../../../model/status";
import { SingleChoice } from "../../../model/singlechoice";
import { Labeler } from "../../../model/labeler";
@Component({
  selector: "status",
  templateUrl: "./status.component.html",
  styleUrls: ["./status.component.css"],
})
export class StatusComponent implements OnInit {
  messages: BehaviorSubject<Messages>;
  @Output() statusSelected = new EventEmitter<number>();
  @Output() createNewStatus = new EventEmitter<void>();
  @Input() isMobile: boolean = false;
  @Input() choiceEvent: SingleChoice = SingleChoice.EMPTY;
  status: BehaviorSubject<Status[]>;

  selectedStatus: Status | null = null;
  filteredStatus: BehaviorSubject<Status[]> = new BehaviorSubject<Status[]>([]);
  searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>("");
  statusCount: number = 0;
  title: BehaviorSubject<string> = new BehaviorSubject<string>("");
  constructor(
    private statusService: StatusService,
    private authService: AuthService,
    private router: Router
  ) {
    this.messages = new BehaviorSubject(Messages.EMPTY);
    this.status = new BehaviorSubject<Status[]>([]);
  }

  ngOnInit(): void {
    this.title.next("status.title");
    const token = this.authService.token;

    this.statusService.status(token).subscribe({
      next: (messages) => {
        if (messages.hasAnyMessages) {
          this.messages.next(messages);
        }
      },
      complete: () => {},
    });

    this.statusService.statusObservable.subscribe((data) => {
      const sortedStatus = data.sort((a: Status, b: Status) =>
        a.name.localeCompare(b.name)
      );
      this.status.next(sortedStatus);
      this.filteredStatus.next(sortedStatus);
      this.statusCount = sortedStatus.length;
    });
  }
  searchStatus(): void {
    const query = this.searchTerm.getValue().toLowerCase();

    const filtered = query
      ? this.status.value.filter((status) =>
          status.name.toLowerCase().includes(query)
        )
      : this.status.value;

    this.filteredStatus.next(filtered);
  }
  select(status: Status) {
    if (this.choiceEvent && this.choiceEvent.topic == "status") {
      if (status && status.id) {
        this.statusService.makeBackgroundColor(status.id).subscribe((color) => {
          const background = color;
          this.statusService.makeColor(status.id!!).subscribe((c) => {
            const color = c;
            this.choiceEvent.choose(
              status.id!!,
              status.name,
              background,
              color,
              1
            );
          });
        });
      }
    } else {
      this.statusService.select(status);

      if (status && status.id) {
        this.router.navigate([`status/${status.id}`]).then(() => {
          this.statusSelected.emit(status.id!!);
        });
      }
    }
  }

  createStatus(): void {
    this.createNewStatus.emit();

    const newStatus = new Status(Navigation.NEW, "", "");
    this.statusService.select(newStatus);
    this.router.navigate([`status/` + Navigation.NEW]).then(() => {
      this.statusSelected.emit(Navigation.NEW);
    });
  }

  clearFilter() {
    this.searchTerm.next("");
    this.filteredStatus.next(this.status.value);
  }
  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }
  get statusLabelerByService(): Labeler {
    return this.statusService;
  }
}
